import { Field } from './Field';

export class TextField extends Field {
  public render(): HTMLElement {
    const container = this.createContainer();

    const input = document.createElement('input');
    input.type = 'text';
    input.id = this.name;
    input.name = this.name;
    input.value = this.value;
    input.addEventListener('input', (event) => {
      const target = event.target as HTMLInputElement;
      this.onChange(target.value);
    });
    container.appendChild(input);

    return container;
  }
}
